/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { confirmEmailResponse, confirmEmailProps } from '@/auth/types';
import { fetchGraphQl } from '../fetch-graphql';
import { CONFIRM_EMAIL } from './graphql/confirmEmail.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';

export const confirmEmail = async ({
  customerEmail,
  customerConfirmationKey,
}: confirmEmailProps): Promise<confirmEmailResponse | undefined> => {
  return await fetchGraphQl(CONFIRM_EMAIL, {
    method: 'POST',
    variables: {
      email: customerEmail,
      confirmation_key: customerConfirmationKey,
    },
  }).catch(handleNetworkError);
};
